import { GenericService } from './generic.service';
import { Episode } from '@/models';

export class PatientEpisodeService extends GenericService<Episode> {

  constructor(organisationId: string, patientId: string) {
    super(`v1/organisations/${organisationId}/patients/${patientId}/episodes`);
  }
}
